import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import {
    DataFieldEditCalendarComponent_Settings,
    TDataFieldEditCalendarComponent_Settings,
} from '@fi-app/data-field/data-field-edit/custom-calendar/custom-calendar.component';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { BusinessUnitModel } from '@fi-app/business-unit/business-unit.model';
import { DataFieldModel } from '@fi-app/data-field/data-field.model';

@Component({
    selector: 'fi-business-unit-edit-other-tab',
    templateUrl: './fi-business-unit-edit-other-tab.component.html',
    styleUrls: ['./fi-business-unit-edit-other-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-business-unit-edit-other-tab' },
    providers: [
        {
            provide: DataFieldEditCalendarComponent_Settings,
            deps: [FiBusinessUnitEditOtherTabComponent],
            useFactory: (): TDataFieldEditCalendarComponent_Settings => ({
                isOutlineLayout: true,
            }),
        },
        { provide: FiComponentsContainer, useExisting: FiBusinessUnitEditOtherTabComponent },
    ],
    standalone: false,
})
export class FiBusinessUnitEditOtherTabComponent extends FiComponentsContainer {
    @Input() dataFields: DataFieldModel[];
    @Input() businessUnit: BusinessUnitModel;
}
